
export const adjustCurrentPage = (totalItems, currentPage, pageSize) => {
  const nextPageStart = ((currentPage - 1) * pageSize)
  return (nextPageStart > (totalItems - 1)) ? 1 : currentPage
}

export const getDataOnPaging = (dataList, pageNo, pageSize) => {
  if (dataList.length < 1) {
    return []
  }

  const start = (pageNo - 1) * pageSize
  const resultList = dataList.splice(start, pageSize)
  return resultList
}

export const filterDataByKeyword = (dataList, keyword, searchKeys = []) => {
  if (dataList.length < 1) {
    return []
  }

  keyword = keyword.toLowerCase()

  const filteredDataList = dataList.filter((item) => {
    const isMatch = searchKeys.some((key) => {
      const isIncluded = (!item.hasOwnProperty(key)) ? false : (item[key].toLowerCase()).includes(keyword)
      return isIncluded
    })

    return isMatch
  })

  return filteredDataList
}
